(function($) {

  $.fn.menumaker = function(options) {
      
      var cssmenu = $(this), settings = $.extend({
        title: "",
        format: "dropdown",
        sticky: false
      }, options);

      return this.each(function() {
        cssmenu.prepend('<div id="menu-button">' + settings.title + '</div>');
        $(this).find("#menu-button").on('click', function(){
          $(this).toggleClass('menu-opened');
          var mainmenu = $(this).next('ul');
          if (mainmenu.hasClass('open')) { 
            mainmenu.hide().removeClass('open');
          }
          else {
            mainmenu.show().addClass('open');
            if (settings.format === "dropdown") {
              mainmenu.find('ul').show();
            }
          }
        });

        cssmenu.find('li ul').parent().addClass('has-sub');

        multiTg = function() {
          cssmenu.find(".has-sub").prepend('<span class="submenu-button"></span>');
          cssmenu.find('.submenu-button').on('click', function() {
            $(this).toggleClass('submenu-opened');
            if ($(this).siblings('ul').hasClass('open')) {
              $(this).siblings('ul').removeClass('open').hide();
            }
            else {
              $(this).siblings('ul').addClass('open').show();
            }
          });
        };

        if (settings.format === 'multitoggle') multiTg();
        else cssmenu.addClass('dropdown');

        if (settings.sticky === true) cssmenu.css('position', 'fixed');

        resizeFix = function() {
         // if ($( window ).width() > 768) {
         //   cssmenu.find('ul').show().removeClass('open');
              //cssmenu.find('ul').removeClass('open');
         // }

          if ($(window).width() <= 768) {
            cssmenu.find('ul').hide().removeClass('open');
          }
        };
        resizeFix();
        return $(window).on('resize', resizeFix);

      });
  };
})(jQuery);

    $(document).ready(function() {
      $("#owl-demo").owlCarousel({
        autoPlay: true,
    navigation:true,
        items : 4,
        itemsDesktop : [1199,3],
        itemsDesktopSmall : [979,3],
      });

$("#owl-brand").owlCarousel({
        autoPlay: true,
    navigation:true,
        items : 4,
        itemsDesktop : [1199,3],
        itemsDesktopSmall : [979,3],
      });

$("#owl-watches").owlCarousel({
        autoPlay: true,
    navigation:true,
        items : 4,
        itemsDesktop : [1199,3],
        itemsDesktopSmall : [979,3],
      });

    });

(function($){
$(document).ready(function(){

$("#cssmenu").menumaker({
   title: "",
   format: "multitoggle"
});


});
})(jQuery);

$(window).scroll(function(){
  var sticky = $('.sticky'),
      scroll = $(window).scrollTop();

  if (scroll >= 100) sticky.addClass('fixed');
        else sticky.removeClass('fixed');
});


function show_calculator()
  {
    
    jQuery('.calculator_quote_area input[name="first_name"]').val((jQuery('#wpcf7-f23-o2 input[name="your-name"]').val()));
    jQuery('.calculator_quote_area input[name="telephone_no"]').val((jQuery('#wpcf7-f23-o2 input[name="phone"]').val()));
    jQuery('.calculator_quote_area input[name="email"]').val((jQuery('#wpcf7-f23-o2 input[name="your-email"]').val()));
    
    jQuery('#form_personal').hide('slow');
    jQuery('#form_calc').show('slow');
    
    
    //Call Tracking Code
    //_gaq.push(['_trackEvent', 'Contact First Page', 'Request Valuation', 'Get Instant Valuation',, false]);   
    // ga('send', 'event', 'contact first page', 'request valuation', 'get instant valuation', 0);
    if (typeof ga !== "undefined") {

      gtag('event', 'request_valation', {
        'event_category': 'form',
        'event_label': 'Get Instant Valuation',
        'value': 1
      });

    }
  }
  
  jQuery(document).ready(function($) {
  jQuery('#shape_select').click(function(){
jQuery('#shape_div').show();
  });
  });

jQuery(document).ready(function($) {
  jQuery('#calculate_price').click(function(){
    var carat = $('span.diamond_wt input').val();
    //var caratInt = parseInt(carat);
    var colour = $('span.diamond_colour select').val();
    var clarity = $('span.diamond_clarity select').val();
    var diamondShape = $('div.modal-body input:checked').val();
    var currency = $('span.currency select').val();
    $.ajax({
          url: "/get_diamond_price.php",
          type: "POST",
          data: "s=" + diamondShape + "&col=" + colour + "&cla=" + clarity + "&wt=" + carat + "&crc=" + currency,
        dataType:"json",
          success: function(outdata){
             //console.log(outdata);
             //var v = parseInt(msg);
             //var ourprice = (carat*v)/2;
             //$('.form-group p').html('Our suggested price*: ' + msg);
         if(outdata.error)
          {
            $('#price_calc_results').html(outdata.msg); 
          }
        else
          {
            $('#price_calc_results').html('Our suggested price*: <span style="font-size: 28px;font-weight: bold;">' + outdata.msg + '</span>');
            $('#calculated_price').val(outdata.price);
                        // dataLayer.push({'event': 'CalculatePrice', 'eventCategory': 'Calculate Price', 'eventAction': 'Click'});
                if (typeof ga !== "undefined") {

                      gtag('event', 'calculate_price', {
                        'event_category': 'form',
                        'event_label': 'Calculate Price',
                        'value': 1
                      });

                }

          }
             //$('#ourprice').val(ourprice);
          }
       });
  });
  
  jQuery('#calculator_quote_check').click(function(){
    $('.calculator_quote_area').toggle('slow');
  });
  
});


   var adiInit = "13101", adiRVO = true;
   var adiFunc = null;
   (function() {
      var adiSrc = document.createElement("script"); adiSrc.type = "text/javascript";
      adiSrc.async = true;
      adiSrc.src = ("https:" == document.location.protocol ? "https://static-ssl" : "http://static-cdn")
        + ".responsetap.com/static/scripts/rTapTrack.min.js";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(adiSrc, s);
   })();


document.addEventListener( 'wpcf7mailsent', function( event ) {
    if ( '569' == event.detail.contactFormId || '23' == event.detail.contactFormId ) {
        show_calculator();
    }
}, false );
    
document.addEventListener( 'wpcf7submit', function( event ) {
    //alert(event.detail.contactFormId);
    if ( '570' == event.detail.contactFormId) {

        //alert("here");
        var request_pack = false;
        
        var request_pack_check = jQuery('#calculator_quote_check');
        
        if (jQuery(request_pack_check).is(":checked")) {
          request_pack = true;
        }

        if (typeof ga !== "undefined" && request_pack) {

            gtag('event', 'checked', {
              'event_category': 'request_diamond_pack',
              'event_label': 'Request Diamond Pack',
              'value': 1,
              'event_callback': function() {
                  location = '/thank-you'
              }
            });


        } else {

          if (typeof ga !== "undefined") {

            gtag('event', 'submit', {
              'event_category': 'form',
              'event_label': 'Contact Us',
              'value': 1,
              'event_callback': function() {
                    location.replace('https://howcashfordiamonds.co.uk/contact-thank-you');
              }
            });

          } else {
           location.replace('https://howcashfordiamonds.co.uk/thank-you');
          }
        }

    }
}, false );
